export { dict } from './copy';
